import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ProgressMeter } from "src/components/Feedback/ProgressMeter";
import { useFormServiceMatchResults } from "src/hooks/useFormServiceMatch";
import { useOrganization } from "src/hooks/useOrganization";
import ClipboardHappy from "src/images/clipboard-happy.svg?react";
import * as Url from "src/services/url";
import { MatchRunError } from "./components/MatchRunError";

export const MatchProgressFormService = () => {
  const { matchId } = useParams<{ matchId: string }>();
  const navigate = useNavigate();
  const organization = useOrganization().withDefault(null);
  const { matchRun, matchProgress, matchRunError } =
    useFormServiceMatchResults(matchId);

  const matchName = matchRun?.name ?? "";

  useEffect(() => {
    if (
      matchRun?.status === "Completed" &&
      organization &&
      matchId &&
      matchRun.id === matchId
    ) {
      navigate(Url.OrgAdmin.Match.details(organization, matchRun.id));
    }
  }, [matchRun, navigate, organization, matchId]);

  return (
    <Box display="flex" flexDirection="column" height="100%" gap={3}>
      <Heading as="h1" size="lg" textAlign="left">
        {matchName}&nbsp;
      </Heading>
      {matchRunError ? (
        <MatchRunError errorMessage={matchRunError} />
      ) : (
        <Flex
          alignItems="center"
          flexDirection="column"
          gap={8}
          justifyContent="center"
          width="100%"
          minHeight="70vh"
        >
          <ClipboardHappy />
          <Flex alignItems="center" gap={2}>
            <Heading as="h6">Running match</Heading>
          </Flex>
          <Text
            variant="body2"
            color="text.secondary"
            textAlign="center"
            maxWidth="300px"
          >
            Hang tight! We are running the match with the selected applicants
          </Text>
          <ProgressMeter
            value={(matchProgress ?? 0) * 100}
            size="lg"
            maxWidth="400px"
            stripeAtFull
          />
        </Flex>
      )}
    </Box>
  );
};
